import { createStorage } from '$logic/lib/storage'
import { Wis } from '$logic/wises/types'

const COLLECTION = 'wises'

export const [wisesStorage, wisesReducer] = createStorage<Wis>(COLLECTION)
